/**
 * @file
 * This file has function that is used across the module.
 */
(function ($, Drupal) {
  'use strict';

  Drupal.jnjethicon_product_localization_utils = {};

  /**
   * Set cookie function.
   *
   * @param cookieName
   *   Cookie name.
   * @param cookieValue
   *   Value to be set on cookie.
   * @param exdays
   *   Time to expire or empty if it should expire on the end of browser section.
   * @param path
   *   Path to set or empty if the path is the root.
   */
  Drupal.jnjethicon_product_localization_utils.setCookie = function (cookieName, cookieValue, exdays, path) {
    var date = new Date();
    var expires = '';
    var setPath = ';path=/';

    if (exdays) {
      date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
      expires = 'expires=' + date.toUTCString() + ';';
    }

    if (path) {
      setPath = setPath + path;
    }

    document.cookie = cookieName + '=' + cookieValue + ';' + expires + setPath;
  };

  /**
   * Get cookie function.
   *
   * @param cname
   *   Cookie name.
   *
   * @returns {string}
   *   Cookie value or empty.
   */
  Drupal.jnjethicon_product_localization_utils.getCookie = function (cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  /**
   * Parse Cookie value.
   *
   * @param cname
   *   Cookie name.
   *
   * @returns {*}
   *   Return parsed value.
   */
  Drupal.jnjethicon_product_localization_utils.parseCookie = function (cname) {
    var cookieValue = this.getCookie(cname);

    if (cookieValue.length !== 0) {
      return JSON.parse(cookieValue);
    }

    return '';
  };

  /**
   * Get querystring parameter by name.
   *
   * @param name
   *   Parameter name.
   * @param url
   *   Optional Url to check.
   *
   * @returns {string}
   *   Return parameter value or empty.
   */
  Drupal.jnjethicon_product_localization_utils.getParameterByName = function(name, url) {
    if (!url) {
      url = window.location.search;
    }

    name = name.replace(/[\[\]]/g, '\\$&');

    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results || !results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  /**
   * Get current region.
   *
   * @returns {string}
   *   Return Region from current url or empty.
   */
  Drupal.jnjethicon_product_localization_utils.getRegionFromURL = function () {
    // USE window.location.pathname to get current region link
    var pathname =window.location.pathname.split('/');

    if (typeof pathname[1] !== 'undefined') {
      return pathname[1];
    }

    return '';
  };

})(jQuery, Drupal);
